const copyUsingTextarea = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  // keep the textarea out of sight without breaking selection
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  const selection = document.getSelection();
  const previousRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  textarea.focus();
  textarea.select();
  // iOS Safari ignores select() on a readonly textarea
  textarea.setSelectionRange(0, text.length);
  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch {
    copied = false;
  }
  document.body.removeChild(textarea);
  if (selection && previousRange) {
    selection.removeAllRanges();
    selection.addRange(previousRange);
  }
  return copied;
};

/**
 * Copies text to the clipboard and reports whether it actually succeeded.
 * The Clipboard API is only available in a secure context (https, localhost),
 * so plain http origins fall back to a hidden textarea.
 */
export const copyToClipboard = async (text: string) => {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return copyUsingTextarea(text);
    }
  }
  return copyUsingTextarea(text);
};
